import React from 'react';
import {
  ExhibitorRepository,
  iExhibitorRepository,
} from 'services/Exhibitor/Exhibitor.repository';
import { UserRepository, iUserRepository } from 'services/User/User.repository';
import {
  MediaRepository,
  iMediaRepository,
} from 'services/Media/Media.repository';
import {
  ProductRepository,
  iProductRepository,
} from 'services/Product/Product.repository';
import {
  CodificationRepository,
  iCodificationRepository,
} from 'services/Codification/Codification.repository';
import {
  ConfirmationRepository,
  iConfirmationRepository,
} from 'services/Confirmation/Confirmation.repository';
import {
  PreferenceRepository,
  iPreferenceRepository,
} from 'services/Preference/Preference.repository';
import {
  EventRepository,
  iEventRepository,
} from 'services/Event/Event.repository';
import {
  ExhibitorEventsRepository,
  iExhibitorsEventRepository,
} from 'services/ExhibitorsEvent/ExhibitorsEvent.repository';
import {
  CompanyRepository,
  iCompanyRepository,
} from './services/Company/Company.repository';
import {
  FloorMapRepository,
  iFloorMapRepository,
} from 'services/FloorMap/FloorMap.repository';
import {
  CategoryRepository,
  iCategoryRepository,
} from 'services/Category/Category.repository';
import { CrmRepository, iCrmRepository } from 'services/Crm/Crm.repository';
import {
  TicketingRepository,
  iTicketingRepository,
} from 'services/Ticketing/Ticketing.repository';

const apiRef = {
  exhibitorRepository: new ExhibitorRepository(),
  userRepository: new UserRepository(),
  mediaRepository: new MediaRepository(),
  productRepository: new ProductRepository(),
  codificationRepository: new CodificationRepository(),
  confirmationRepository: new ConfirmationRepository(),
  preferenceRepository: new PreferenceRepository(),
  eventRepository: new EventRepository(),
  exhibitorEventRepository: new ExhibitorEventsRepository(),
  companyRepository: new CompanyRepository(),
  floorMapRepository: new FloorMapRepository(),
  categoryRepository: new CategoryRepository(),
  crmRepository: new CrmRepository(),
  ticketingRepository: new TicketingRepository(),
};

export interface iApiContext {
  exhibitorRepository: iExhibitorRepository;
  userRepository: iUserRepository;
  mediaRepository: iMediaRepository;
  productRepository: iProductRepository;
  codificationRepository: iCodificationRepository;
  confirmationRepository: iConfirmationRepository;
  preferenceRepository: iPreferenceRepository;
  eventRepository: iEventRepository;
  exhibitorEventRepository: iExhibitorsEventRepository;
  companyRepository: iCompanyRepository;
  floorMapRepository: iFloorMapRepository;
  categoryRepository: iCategoryRepository;
  crmRepository: iCrmRepository;
  ticketingRepository: iTicketingRepository;
}

const ApiContext = React.createContext<iApiContext>(apiRef);

function ApiProvider({ children }: { children: React.ReactNode }): JSX.Element {
  return <ApiContext.Provider value={apiRef}>{children}</ApiContext.Provider>;
}

export default ApiContext;
export { ApiProvider };
